export type { ClientFormValues } from './types/client-form';
export type { OtpFormValues } from './types/otp-form';
export type { ModalOpenerType } from './types/general';

export { default } from './client-otp-modal';
